import { createAction, createPayloadAction } from 'helpers/actionsHelpers'
import { SimpleAction, PayloadAction } from 'interfaces/action'

type WithImage = {
  image: Blob
}

export const CROP_IMAGE = 'CROP_IMAGE' as const
export const cropImageActionCreator =
  (payload: WithImage): PayloadAction<typeof CROP_IMAGE, WithImage> =>
    createPayloadAction(CROP_IMAGE, payload)
type CropImage = ReturnType<typeof cropImageActionCreator>

export const CROP_IMAGE_RESULT = 'CROP_IMAGE_RESULT' as const
export const cropImageResultActionCreator =
  (payload: WithImage): PayloadAction<typeof CROP_IMAGE_RESULT, WithImage> =>
    createPayloadAction(CROP_IMAGE_RESULT, payload)
type CropImageResult = ReturnType<typeof cropImageResultActionCreator>

export const CLEAR_CROPPER = 'CLEAR_CROPPER' as const
export const clearCropperActionCreator = (): SimpleAction<typeof CLEAR_CROPPER> => createAction(CLEAR_CROPPER)
export type ClearCropper = ReturnType<typeof clearCropperActionCreator>

export type CropperAction =
  | CropImage
  | CropImageResult
  | ClearCropper
